<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Atividade Coletiva"
            description="Gerenciar atividades coletivas e editar participantes"
            url="/oficinas-treinamentos-facilitador"
            :enabledModalInformacao="true"
            :enabledIframeModalInformacao="true"
            urlIframeModalInformacao="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-9111"
            pageIdentifier="ficha-atividade-coletiva"
            :enableBadgeModalInformacao="
              Number(
                $store.state.permissoesRaw?.ficha_atividade_coletiva_ajuda || 0
              ) > 0
            "
            :badgeValueModalInformacao="
              $store.state.permissoesRaw?.ficha_atividade_coletiva_ajuda || 0
            "
            keyAjudaModalInformacao="ficha_atividade_coletiva_ajuda"
          />
        </div>
      </div>
      <router-view></router-view>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from "@/components/Menu";
import Footer from "@/components/Footer";
import SectionTitle from "@/components/SectionTitle";

export default {
  components: { Menu, Footer, SectionTitle },
};
</script>

<style></style>